import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

/**
 * Fetches stats for 2 received ranges using combined GQL queries
 * @param {object} param.firstRange First range for which we want to have stats on order to commpare them
 * @param {object} param.secondRange Second range for which we want to have stats on order to commpare them
 * @param {number} param.cityId ID of the city
 * @example
 * fetchKPIStatsCombined({
 *   firstRangeDefault: {
 *     startDate: new Date(currentYear, currentMonth, 1), // First day of the current month
 *     endDate: now, // Now
 *   },
 *   secondRangeDefault: {
 *     startDate: new Date(currentYear, currentMonth - 1, 1), // First day of the previous month
 *     endDate: new Date(currentYear, currentMonth, 0), // Last day of the previous month
 *   },
 *   cityId: 1
 * })
 */
export const fetchKPIStatsCombined = async ({
  firstRange,
  secondRange,
  cityId,
}) => {
  const query = `
    query (
      $firstRangeStartDate: String,
      $firstRangeEndDate: String, 
      $secondRangeStartDate: String, 
      $secondRangeEndDate: String, 
      $cityId: ID!
      ) {
        firstStats: stats(
          startDate:$firstRangeStartDate, 
          endDate:$firstRangeEndDate, 
          cityId:$cityId
          ){
            totalActiveBAs
            totalActiveBAsThatBooked
            totalMissionsCreated
            totalMissionsCompleted
            totalNewBAs
            totalNewBAsThatBooked
            totalSpiedMissions
        }
        secondStats: stats(
          startDate:$secondRangeStartDate, 
          endDate:$secondRangeEndDate, 
          cityId:$cityId
          ){
            totalActiveBAs
            totalActiveBAsThatBooked
            totalMissionsCreated
            totalMissionsCompleted
            totalNewBAs
            totalNewBAsThatBooked
            totalSpiedMissions
        }
        currentStats: city(id:$cityId){
          brandAmbassadors (statuses:[ACTIVE]){
            totalCount
          }
        }
    }
`

  const res = await callAuthorizedGraphQLEndpoint(query, {
    firstRangeStartDate: firstRange.startDate,
    firstRangeEndDate: firstRange.endDate,
    secondRangeStartDate: secondRange.startDate,
    secondRangeEndDate: secondRange.endDate,
    cityId,
  })

  const { data } = await res.json()

  return data
}



// WEBPACK FOOTER //
// ./src/Containers/StatsKPI/graphQL.js